export default __webpack_public_path__ + "static/media/Bhart Vikash Parisad Sample Certificate.e12ce9f5e977f72ffcd5ec13d5bdd723.jpeg";